var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row middle-align-flex footer"},[_c('div',[_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.footerText)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }